<form style="width: 400px; min-width: 50%">
  <h1 mat-dialog-title></h1>
  <div class="container">
    <div mat-dialog-content>
      <div class="row m-0">
        <mat-form-field class="col-lg-4 col-sm-12">
          <mat-label>{{'Contribute.thCOF' | translate}}</mat-label>
          <input type="text" (focusout)="calculateFSACOF()" matInput placeholder="{{'Contribute.thCOF' | translate}}"
            [(ngModel)]="contribution.rate" [ngModelOptions]="{standalone: true}" required [readonly]="contribution.level !== 3"/>
          </mat-form-field>
          <mat-form-field class="col-lg-4 col-sm-12">
            <mat-label>{{'Contribute.thNewSpread' | translate}}</mat-label>
            <input type="text" (focusout)="calculateFSACOF()" (keyup)="checkSpread()" matInput placeholder="{{'Contribute.thNewSpread' | translate}}"
              [(ngModel)]="contribution.spread" [ngModelOptions]="{standalone: true}" required />
            </mat-form-field>
            <mat-form-field class="col-lg-4 col-sm-12">
              <mat-label>{{'Contribute.thFSACOF' | translate}}</mat-label>
              <input type="text" matInput placeholder="{{'Contribute.thFSACOF' | translate}}"
                [(ngModel)]="contribution.fsaCOF" [ngModelOptions]="{standalone: true}" readonly />
              </mat-form-field>
            </div>
            <mat-form-field class="col-12">
              <mat-label>{{'Contribute.lblReason' | translate}}</mat-label>
              <mat-select [(ngModel)]="contribution.reasonId" [ngModelOptions]="{standalone: true}" [required]="isReasonRequired" [disabled]="isReasonRequired == false">
                @for (reason of reasons; track reason) {
                  <mat-option [value]="reason.id">{{reason.value}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="col-12">
              <mat-label>{{'Contribute.thComments' | translate}}</mat-label>
              <input type="text" matInput placeholder="{{'Contribute.thComments' | translate}}"
                [(ngModel)]="contribution.comments" [ngModelOptions]="{standalone: true}" />
              </mat-form-field>
            </div>
            <div mat-dialog-actions>
              <button mat-raised-button color="primary" (click)="OnClickOk()">{{'btnOk' | translate}}</button>&nbsp;
              <button mat-raised-button color="secondary" (click)="OnCancel()">{{'btnCancel' | translate}}</button>
            </div>
          </div>
        </form>
